<template>
  <div v-loading.fullscreen.lock="ui.isLoading" class="app-root">
    <router-view v-slot="{ Component, route }">
      <component :is="Component" :key="route.fullPath" />
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
</script>

<style>
#app {
  height: 100vh;
  overflow: hidden;
  min-height: 100vh;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-root {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.bootstrap-error {
  padding: 48px;
  color: #c45656;
  text-align: center;
}
</style>
